import React, { useContext, useState } from 'react';
import { StructuredListing } from '@hz-design-system/web-ui';
import { formatImageUrl, ImageSize } from '@ecg-internal/media-util-js-lib';
import { useI18nContext } from '@ecg-internal/js-react-i18n';

import EnvironmentContext from '../../../contexts/EnvironmentContext';
import createFavorite from '../../../repositories/createFavorite';
import deleteFavorite from '../../../repositories/deleteFavorite';
import { trackGAEvent } from '../../../utils/gaTracking';
import formatPrice from '../../FeedsApp/components/Feeds/utils/formatPrice';

type TSearchFeedItemProps = {
  listing: any;
  toggleFavorite: any;
};

const SearchFeedItem = ({ listing, toggleFavorite }: TSearchFeedItemProps) => {
  const { t } = useI18nContext();
  const { isInApp, userLoggedIn, xsrfToken, links } = useContext(EnvironmentContext);
  const [isFavorite, setIsFavorite] = useState<boolean>(listing.isFavorited);
  const withFavoriting = !isInApp || userLoggedIn;

  const onFavorite = async () => {
    const isFav = isFavorite;

    if (userLoggedIn) {
      setIsFavorite(!isFav);
      if (isFav) {
        trackGAEvent('WatchlistRemoveBegin');
        await deleteFavorite(listing.itemId, xsrfToken);
        trackGAEvent('WatchlistRemoveSuccess');
      } else {
        trackGAEvent('WatchlistAddBegin');
        await createFavorite(listing.itemId, xsrfToken);
        trackGAEvent('WatchlistAddSuccess');
      }
      toggleFavorite(listing.itemId);
    } else {
      window.location.assign(`${links.loginAccountUrl}?target=${encodeURIComponent(window.location.href)}`);
    }
  };

  return (
    <StructuredListing
      title={listing.title}
      price={listing.priceInfo ? formatPrice(listing.priceInfo, t, true, listing.isPricePerMonth) : ''}
      imageSrc={formatImageUrl(listing.picture?.url, ImageSize.Large, listing.picture?.sizes)}
      imageLoading="lazy"
      decoding="async"
      isMaskedLink={!!listing.thinContent}
      onHeart={onFavorite}
      isFavorite={isFavorite}
      showFav={withFavoriting}
      favAriaLabel={isFavorite ? t('listing.favourite.ariaLabel.remove') : t('listing.favourite.ariaLabel.add')}
      linkProps={{ href: listing.url }}
    />
  );
};

export default SearchFeedItem;
